<!--
@Time : 2020/9/9 9:04 上午
@Author : yekong
@File : top.vue
@Software : PhpStorm
-->
<template>
  <div class="top">
    <div class="lefts">
      营商环境智能监控中心
    </div>
    <div class="rights">
      <topnav :defaultIndex="defaultIndex"></topnav>
    </div>
  </div>
</template>

<script>
import topnav from "@/components/head/topnav";

export default {
  name: "top",
  components: {topnav},
  props: {
    defaultIndex: {
      // 要显示的数组
      type: Number,
      default() {
        return 0;
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  width: 3840px;
  position: absolute;
  z-index: 1;

  .lefts {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
    font-size: 84px;
    font-family: HYLingXinJ;
    font-weight: 400;
    color: #FFFFFF;
    background: linear-gradient(0deg, #C3DBFF 0%, #E3F2FF 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    padding-left: 139px;
    height: 170px;
    padding-top: 70px;
  }
}
</style>
